import { ProjectStatus } from "@planzone/dto";
import { Repository } from "../../adapters/repository";
import { present } from "../../../utils/presenter";
import { Interactor } from "./types";

function hashCode(str: string) {
  let hash = 0;

  for (let i = 0; i < str.length; i++) {
    hash = str.charCodeAt(i) + ((hash << 5) - hash);
  }

  return hash;
}

function intToRGB(i: number) {
  const c = (i & 0x00ffffff).toString(16).toUpperCase();

  return "00000".substring(0, 6 - c.length) + c;
}

function generateRandomColor({ label }: ProjectStatus) {
  return `#${intToRGB(hashCode(label))}`;
}

function createInteractor(repository: Repository): Interactor {
  return ({ planzone, status }) =>
    present(
      repository
        .saveProjectStatus(planzone, {
          ...status,
          color: status.color || generateRandomColor(status),
        })
        .then((savedStatus) => ({ planzone, status: savedStatus }))
        .catch((error) => Promise.reject({ error, status, planzone })),
    );
}

export type { Interactor };

export { createInteractor };
